export default __webpack_public_path__ + "static/media/fMaltoBuza1.21ab9362.png";